import modelBaseV2 from "../model-base-v2.model";

/**
 * Division Model
 * 
 * Contains all Division specific requests
 * 
 * @author CV Leong
 */
const DivisionModel = {

  getDivisionList: () => {
    return modelBaseV2.get(`/api/division/list`);
  },

  getUserDivisions: () => {
    return modelBaseV2.get('/api/division/getdivision');
  },

  getBrandListByDivision: () => {
    return modelBaseV2.get('/api/division/getbrandlistbydivision');
  }

};

export default DivisionModel;